var exports = {
  "vK": "banner__6RyoSN",
  "Am": "bannerMuted__STVqP7",
  "Kk": "icon__AhCKqw",
  "DD": "title__-TRbTf",
  "nf": "link__mO-11U",
  "VN": "close__8UTZ05",
  "YE": "closeWrapper__mVFCDr",
};

module.exports = exports;
